import { Modal } from 'bootstrap'
import React,{useState,useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateDestination,fetchAllDestination } from '../../../../../Redux/slice/features/destinationSlice'
import { fetchDistrict } from '../../../../../Redux/slice/features/districtSlice'


const EditDestination = ({ editData, onClose }) => {
    const dispatch = useDispatch();
    const alldistrict=useSelector((state)=> state.district.districtData);
  
    useEffect(() => {
        dispatch(fetchDistrict());
      }, [dispatch]);

  const [formData, setFormData] = useState({
    id: '', // Add an id field to identify the destination being updated
    district: '',
    code: '',
    destination: '',
    category: '',
    attractionpoint: '',
  });

  useEffect(() => {
    if (editData) {
      setFormData({
        id: editData.id, // Set the id from editData
        district: editData.district,
        code: editData.code,
        destination: editData.destination,
        category: editData.category,
        attractionpoint: editData.attractionpoint,
      });
    }
  }, [editData, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();     
    dispatch(updateDestination(formData))
    .unwrap() // This allows you to handle the promise returned by the thunk
    .then(() => {
      alert("Update successful");
      
       onClose(); // Close the modal
      dispatch(fetchAllDestination()); // Refresh the destination list
    })
    .catch((error) => {
      console.error("Update failed: ", error);
      alert("Failed to update destination: " + error.message);
    });
  };
  return (
    <div className="modal fade" id="edit-destination" tabIndex="-1"  aria-hidden="true">
		<div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Edit Destination</h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label className="form-label text-muted">District </label>
                            <select className="form-select" name="district" value={formData.district}
                      onChange={handleChange}>
                                            <option defaultValue='selected'>Select District</option>
                                            {alldistrict.map((districts) => (
                                                <option key={districts.id} value={districts.district_name}>
                                                    {districts.district_name}
                                                </option>
                                            ))}
                                
                            </select>
                        </div>
                        <div className="form-group mb-3">
                            <label className="form-label text-muted">District Code</label>
                            <input type="text" name="code" className="form-control" value={formData.code} onChange={handleChange}/>
                        </div>
                        <div className="form-group">
                            <label className="form-label text-muted">Destination</label>
                            <input type="text" className="form-control" name="destination" value={formData.destination} onChange={handleChange}/>
                        </div>
                        <div className="form-group">
                            <label className="form-label text-muted">Category</label>
                            <select className="form-select" name="category"
                      value={formData.category}
                      onChange={handleChange}
                    >
                      <option value="">Select Category</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                    </select>
                        </div>
                        <div className="form-group">
                            <label className="form-label text-muted">Attraction Point</label>
                            <input type="text" className="form-control" name="attractionpoint" value={formData.attractionpoint} onChange={handleChange}/>
                        </div>
                        <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={onClose}>Close</button>
                <button type="submit" className="btn" data-bs-dismiss="modal" >Update</button>
                </div>
                    </form>
                </div>
                
            </div>
		</div>
	</div>
  )
}

export default EditDestination